export default "__VITE_PUBLIC_ASSET__2c62ae45__"